/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AllGamesQuestsGameInfo
 */
export interface AllGamesQuestsGameInfo {
    /**
     * 
     * @type {string}
     * @memberof AllGamesQuestsGameInfo
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof AllGamesQuestsGameInfo
     */
    gameId?: string;
    /**
     * 
     * @type {string}
     * @memberof AllGamesQuestsGameInfo
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AllGamesQuestsGameInfo
     */
    slug?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AllGamesQuestsGameInfo
     */
    isEventSupported?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AllGamesQuestsGameInfo
     */
    questCount?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AllGamesQuestsGameInfo
     */
    steamData?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AllGamesQuestsGameInfo
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {string}
     * @memberof AllGamesQuestsGameInfo
     */
    thumbnailImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AllGamesQuestsGameInfo
     */
    devourGameLogo?: string;
}

/**
 * Check if a given object implements the AllGamesQuestsGameInfo interface.
 */
export function instanceOfAllGamesQuestsGameInfo(value: object): value is AllGamesQuestsGameInfo {
    return true;
}

export function AllGamesQuestsGameInfoFromJSON(json: any): AllGamesQuestsGameInfo {
    return AllGamesQuestsGameInfoFromJSONTyped(json, false);
}

export function AllGamesQuestsGameInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllGamesQuestsGameInfo {
    if (json == null) {
        return json;
    }
    return {
        
        '_id': json['_id'] == null ? undefined : json['_id'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'name': json['name'] == null ? undefined : json['name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'isEventSupported': json['isEventSupported'] == null ? undefined : json['isEventSupported'],
        'questCount': json['questCount'] == null ? undefined : json['questCount'],
        'steamData': json['steamData'] == null ? undefined : json['steamData'],
        'thumbnailImage': json['thumbnailImage'] == null ? undefined : json['thumbnailImage'],
        'thumbnailImageUrl': json['thumbnailImageUrl'] == null ? undefined : json['thumbnailImageUrl'],
        'devourGameLogo': json['devourGameLogo'] == null ? undefined : json['devourGameLogo'],
    };
}

export function AllGamesQuestsGameInfoToJSON(json: any): AllGamesQuestsGameInfo {
    return AllGamesQuestsGameInfoToJSONTyped(json, false);
}

export function AllGamesQuestsGameInfoToJSONTyped(value?: AllGamesQuestsGameInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['_id'],
        'gameId': value['gameId'],
        'name': value['name'],
        'slug': value['slug'],
        'isEventSupported': value['isEventSupported'],
        'questCount': value['questCount'],
        'steamData': value['steamData'],
        'thumbnailImage': value['thumbnailImage'],
        'thumbnailImageUrl': value['thumbnailImageUrl'],
        'devourGameLogo': value['devourGameLogo'],
    };
}

